

export default {
    name: "ChatSayImage",
    props: {
        imageUrl: String,
    },
    computed: {
        imageList() {
            return [this.imageUrl]
        }
    },
    methods: {
        onCopy() {
            this.$copy(this.imageUrl)
        },
        onPreview() {
            this.$refs.preview.clickHandler();
        }

    }
}
